import React from 'react';
import PropTypes from 'prop-types';
import { CanceledIcon, CompleteIcon } from 'assets/materialIcons/materialIcons';
import { colors } from 'material-ui/styles';

const StatusField = (props) => {
    const { record, source } = props;

    // If the record has not been set yet.
    if (!record) {
        return null;
    }

    // If the record contains an property of source and contains a value
    if (!record.hasOwnProperty(source) && !record[source]) {
        return null;
    }

    /**
     * This toggleStatus checks what the status is and returns a suitable component.
     *
     * @param {bool} status
     */
    function toggleStatus(status) {
        if (!status) {
            return <CanceledIcon color={ colors.grey400 } />;
        }

        return <CompleteIcon color={ colors.lightGreen500 } />;
    }

    return (
        <div style={ { 'marginLeft': '15px' } }>
            { toggleStatus(record[source]) }
        </div>
    );
};

StatusField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string,
};

export default StatusField;



// WEBPACK FOOTER //
// ./src/components/field/StatusField.js